import { React } from 'react';
import robot_image from '../Assets/Images/robot_image.png';
import charts_image from '../Assets/Images/blueprints1.png';
import video from '../Assets/videos/vd2.mp4'
import robot from '../Assets/Images/underwater-drone-robix-FTWZK5W-1024x748.png'
import robot2 from '../Assets/Images/image 3234.png'
import proven_icon from '../Assets/icon/Group.png';
import long_term_icon from '../Assets/icon/Group1.png';
import dfm_icon from '../Assets/icon/Group2.png';

const OurServices = () => {
    return (
        <>
        <div className="elementor-element elementor-element-6ba56a1 e-flex e-con-boxed e-con e-parent" data-id="6ba56a1" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' data-core-v316-plus="true">
        <div className="e-con-inner">
    <div className="elementor-element elementor-element-01bfbcf elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="01bfbcf" data-element_type="widget" data-widget_type="heading.default">
    <div className="elementor-widget-container">
<h5 className="elementor-heading-title elementor-size-default">Our Services</h5>		</div>
    </div>
    <div className="elementor-element elementor-element-c1b8026 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="c1b8026" data-element_type="widget" data-widget_type="heading.default">
    <div className="elementor-widget-container">
<h2 className="elementor-heading-title elementor-size-default">Peak-Performance System Services</h2>		</div>
    </div>
    <div className="elementor-element elementor-element-af635cf elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="af635cf" data-element_type="widget" data-widget_type="text-editor.default">
    <div className="elementor-widget-container">
                <p>We provide cutting-edge solutions designed to optimize systems and ensure peak performance, tailored to meet your business needs.</p>						</div>
    </div>
<div className="elementor-element elementor-element-8b235e3 e-flex e-con-boxed e-con e-child" data-id="8b235e3" data-element_type="container" data-settings='{"content_width":"boxed"}'>
        <div className="e-con-inner">
<div className="elementor-element elementor-element-3206d56 e-con-full e-flex e-con e-child" data-id="3206d56" data-element_type="container" data-settings='{"content_width":"full","background_background":"gradient"}'>
<div className="elementor-element elementor-element-1708f4f e-con-full e-flex e-con e-child" data-id="1708f4f" data-element_type="container" data-settings='{"content_width":"full"}'>
<div className="elementor-element elementor-element-8645fa7 e-flex e-con-boxed e-con e-child" data-id="8645fa7" data-element_type="container" data-settings='{"content_width":"boxed"}'>
        <div className="e-con-inner">
    <div className="elementor-element elementor-element-075d960 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="075d960" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div className="elementor-widget-container">
<div className="jeg-elementor-kit jkit-icon-box icon-position- elementor-animation- jeg_module_6_16_676b7979024f1" ><div className="jkit-icon-box-wrapper hover-from-left"><div className="icon-box icon-box-body">
    <h3 className="title">AUTOMATION SOLUTION</h3>
    <p className="icon-box-description">We provide innovative automation solutions designed to streamline processes, enhance productivity, and drive operational excellence.</p><div className="icon-box-button ">
    <div className="btn-wrapper icon-position-after">
        <a href="#" className="icon-box-link" >Learn More<i aria-hidden="true" className="jki jki-right-arrow-light"></i></a>
    </div>
</div>
</div>

</div></div>		</div>
    </div>
        </div>
    </div>
    </div>
<div className="elementor-element elementor-element-aa91c92 e-con-full e-flex e-con e-child" data-id="aa91c92" data-element_type="container" data-settings='{"content_width":"full"}'>
    <div className="elementor-element elementor-element-14bd983 e-transform elementor-widget elementor-widget-image" data-id="14bd983" data-element_type="widget" data-settings='{"_transform_translateX_effect_hover":{"unit":"px","size":-16,"sizes":[]},"_transform_translateX_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateX_effect_hover_mobile":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_mobile":{"unit":"px","size":"","sizes":[]}}' data-widget_type="image.default">
    <div className="elementor-widget-container">
                                                <img loading="lazy" decoding="async" width="754" height="803" src={robot_image} className="attachment-large size-large wp-image-375" alt="" srcSet={robot_image} sizes="(max-width: 754px) 100vw, 754px" />															
                                                </div>
    </div>
    </div>
    </div>
<div className="elementor-element elementor-element-bd928d0 e-con-full e-flex e-con e-child" data-id="bd928d0" data-element_type="container" data-settings='{"content_width":"full","background_background":"gradient"}'>
    <div className="elementor-element elementor-element-2cffe84 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="2cffe84" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div className="elementor-widget-container">
<div className="jeg-elementor-kit jkit-icon-box icon-position- elementor-animation- jeg_module_6_17_676b797905d73" ><div className="jkit-icon-box-wrapper hover-from-left"><div className="icon-box icon-box-body">
    <h3 className="title">DFM - Design For Manufacturing</h3><p className="icon-box-description">We provide Design for Manufacturing solutions to optimize products for cost-efficiency, quality, and scalability.</p><div className="icon-box-button ">
    <div className="btn-wrapper icon-position-after">
        <a href="#" className="icon-box-link" >Learn More<i aria-hidden="true" className="jki jki-right-arrow-light"></i></a>
    </div>
</div>
</div>

</div></div>		</div>
    </div>
    <div className="elementor-element elementor-element-f494906 e-transform elementor-widget elementor-widget-image" data-id="f494906" data-element_type="widget" data-settings='{"_transform_translateX_effect_hover":{"unit":"px","size":-16,"sizes":[]},"_transform_translateX_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateX_effect_hover_mobile":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_mobile":{"unit":"px","size":"","sizes":[]}}' data-widget_type="image.default">
    <div className="elementor-widget-container our-service">
                                                <img loading="lazy" decoding="async" width="800" height="534" src={charts_image} className="mt-[-100px] attachment-large size-large wp-image-461" alt="" srcSet={charts_image} sizes="(max-width: 800px) 100vw, 800px" />															</div>
    </div>
    </div>
        </div>
    </div>
<div className="elementor-element elementor-element-a886e74 e-flex e-con-boxed e-con e-child" data-id="a886e74" data-element_type="container" data-settings='{"content_width":"boxed"}'>
        <div className="e-con-inner">
<div className="elementor-element elementor-element-0d7c9f7 e-con-full e-flex e-con e-child" data-id="0d7c9f7" data-element_type="container" data-settings='{"content_width":"full","background_background":"gradient"}'>
    <div className="elementor-element elementor-element-70ceba6 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="70ceba6" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div className="elementor-widget-container">
<div className="jeg-elementor-kit jkit-icon-box icon-position- elementor-animation- jeg_module_6_18_676b7979097d8" ><div className="jkit-icon-box-wrapper hover-from-left"><div className="icon-box icon-box-body">
    <h3 className="title">BTP - Build to Print</h3><p className="icon-box-description">We provide Build to Print services, delivering precision-built products that meet your exact specifications.</p><div className="icon-box-button ">
    <div className="btn-wrapper icon-position-after">
        <a href="#" className="icon-box-link" >Learn More<i aria-hidden="true" className="jki jki-right-arrow-light"></i></a>
    </div>
</div>
</div>

</div></div>		</div>
    </div>
    <div className="elementor-element elementor-element-986bd98 e-transform elementor-widget elementor-widget-image" data-id="986bd98" data-element_type="widget" data-settings='{"_transform_translateX_effect_hover":{"unit":"px","size":-16,"sizes":[]},"_transform_translateX_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateX_effect_hover_mobile":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_mobile":{"unit":"px","size":"","sizes":[]}}' data-widget_type="image.default">
    <div className="elementor-widget-container">
<img loading="lazy" decoding="async" width="800" height="584" src={robot} className="attachment-large size-large wp-image-467" alt="" sizes="(max-width: 800px) 100vw, 800px" />															</div>
    </div>
    </div>
<div className="elementor-element elementor-element-36fceae e-con-full e-flex e-con e-child" data-id="36fceae" data-element_type="container" data-settings='{"content_width":"full","background_background":"gradient"}'>
<div className="elementor-element elementor-element-2ff7176 e-con-full e-flex e-con e-child" data-id="2ff7176" data-element_type="container" data-settings='{"content_width":"full"}'>
<div className="elementor-element elementor-element-f44dcfd e-flex e-con-boxed e-con e-child" data-id="f44dcfd" data-element_type="container" data-settings='{"content_width":"boxed"}'>
        <div className="e-con-inner">
    <div className="elementor-element elementor-element-2bcf492 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="2bcf492" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div className="elementor-widget-container">
<div className="jeg-elementor-kit jkit-icon-box icon-position- elementor-animation- jeg_module_6_19_676b79790cb0a" ><div className="jkit-icon-box-wrapper hover-from-left"><div className="icon-box icon-box-body">
    <h3 className="title">Smart Factory Automation</h3><p className="icon-box-description">We deliver cutting-edge Smart Factory Automation solutions, leveraging advanced technologies <br/> to enhance efficiency and real-time <br/> operational control.</p><div className="icon-box-button ">
    <div className="btn-wrapper icon-position-after">
        <a href="#" className="icon-box-link" >Learn More<i aria-hidden="true" className="jki jki-right-arrow-light"></i></a>
    </div>
</div>
</div>

</div></div>		</div>
    </div>
        </div>
    </div>
    </div>
<div className="elementor-element elementor-element-fc58a15 e-con-full e-flex e-con e-child" data-id="fc58a15" data-element_type="container" data-settings='{"content_width":"full"}'>
    <div className="elementor-element elementor-element-49774ee e-transform elementor-widget elementor-widget-image" data-id="49774ee" data-element_type="widget" data-settings='{"_transform_translateX_effect_hover":{"unit":"px","size":-16,"sizes":[]},"_transform_translateX_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateX_effect_hover_mobile":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_tablet":{"unit":"px","size":"","sizes":[]},"_transform_translateY_effect_hover_mobile":{"unit":"px","size":"","sizes":[]}}' data-widget_type="image.default">
    <div className="elementor-widget-container">
                                                <img loading="lazy" decoding="async" width="800" height="548" src={robot2} className="attachment-large size-large wp-image-451" alt="" srcSet={robot2} sizes="(max-width: 700px) 50vw, 700px" />															</div>
    </div>
    </div>
    </div>
        </div>
    </div>
        </div>

<div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
            <div className="e-con-inner">
                <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}'>
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}'>
                            <div className="e-con-inner">
                                <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
                                    <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
                                        <div className="elementor-widget-container">
                                            <h2 className="elementor-heading-title elementor-size-default" style={{marginBottom:'15px', textAlign:'left', marginLeft:'-30px'}}>HHG’s Tailored Automation Machine Design & Engineering</h2>
                                        </div>
                                        
                                    </div>
                                    <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
                                        <div className="elementor-widget-container">
                                            <h3 className="elementor-heading-title elementor-size-default" style={{color:'#004E98', marginBottom:'35px', marginLeft:'-30px'}}>Key Principles in Machine/System Design</h3>
                                            <ul style={{ listStyleType: 'disc', lineHeight:'40px' }}>
                                                <li>Business and product planning & goals</li>
                                                <li>KPIs and operational metrics</li>
                                                <li>Understanding added-value Product Costs at each stage</li>
                                                <li>System Flexibility</li>
                                                <li>Contingency planning for disruption or failures</li>
                                                <li>Automation the machine design as much as possible</li>
                                                <li>Performance reporting and feedback serviceability</li>
                                                <li>And more...</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                          <div
  className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child"
  data-id="47da202"
  data-element_type="container"
  data-settings='{"background_background":"classic","content_width":"full"}'
  style={{
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  }}
>
  <video
    className="custom-video"
    autoPlay
    muted
    loop
    playsInline
    ref={(video) => { if (video) video.play(); }}
    style={{
      borderRadius: '10px',
      width: '100%',
      height: '600px', // Desktop height — adjust as needed
      maxWidth: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  >
    <source src={video} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>

  <div className="elementor-element elementor-element-new-section e-flex e-con-boxed e-con e-parent" data-id="new-section" data-element_type="container" data-settings='{"content_width":"boxed"}'>
  <div
    className="e-con-inner flex flex-row justify-between"
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      position: 'relative', // important
      marginBottom:'200px'
    }}
  >
    
    {/* Item 1 */}
    <div className="elementor-element elementor-element-new-item1 e-flex e-con-boxed e-con e-child" data-id="new-item1" data-element_type="container" style={{ width: '32%', marginRight: '1%', paddingRight: '20px', boxSizing: 'border-box' }}>
      <div className="e-con-inner">
        <div className="elementor-element-icon1 elementor-widget elementor-widget-image">
          <div className="elementor-widget-container" style={{ display: 'grid', marginBottom: '20px' }}>
            <img src={proven_icon} alt="Proven & Reliable Process" />
          </div>
        </div>
        <div className="elementor-element-title1 elementor-widget elementor-widget-heading">
          <div className="elementor-widget-container">
            <h3 className="elementor-heading-title" style={{ fontSize: '20px', color: '#004E98', marginBottom: '10px' }}>Proven & Reliable Process</h3>
          </div>
        </div>
        <div className="elementor-element-desc1 elementor-widget elementor-widget-text-editor">
          <div className="elementor-widget-container">
            <p style={{ fontSize: '18px' }}>Addresses all machine, business, and product needs.</p>
          </div>
        </div>
      </div>
    </div>

    {/* Vertical Line */}
   <div
      style={{
        position: 'absolute',
        left: '33.3%',
        top: '0',
        bottom: '0',
        width: '2px',
        backgroundColor: '#d3d3d3',
        zIndex: 5,
      }}
    />


    {/* Item 2 */}
    <div className="elementor-element elementor-element-new-item2 e-flex e-con-boxed e-con e-child" data-id="new-item2" data-element_type="container" style={{ width: '32%', marginRight: '1%', padding: '0 20px', boxSizing: 'border-box' }}>
      <div className="e-con-inner">
        <div className="elementor-element-icon2 elementor-widget elementor-widget-image">
          <div className="elementor-widget-container" style={{ display: 'grid', marginBottom: '20px' }}>
            <img src={long_term_icon} alt="Long-Term Success & Profitability" />
          </div>
        </div>
        <div className="elementor-element-title2 elementor-widget elementor-widget-heading">
          <div className="elementor-widget-container">
            <h3 className="elementor-heading-title" style={{ fontSize: '20px', color: '#004E98', marginBottom: '10px' }}>Long-Term Success & Profitability</h3>
          </div>
        </div>
        <div className="elementor-element-desc2 elementor-widget elementor-widget-text-editor">
          <div className="elementor-widget-container">
            <p style={{ fontSize: '18px' }}>Focuses on worry-free productivity and sustainable performance.</p>
          </div>
        </div>
      </div>
    </div>

    {/* Vertical Line */}
    <div
      style={{
        position: 'absolute',
        left: '66.6%',
        top: '0',
        bottom: '0',
        width: '2px',
        backgroundColor: '#d3d3d3',
        zIndex: 5,
      }}
    />

    {/* Item 3 */}
    <div className="elementor-element elementor-element-new-item3 e-flex e-con-boxed e-con e-child" data-id="new-item3" data-element_type="container" style={{ width: '32%', paddingLeft: '20px', boxSizing: 'border-box' }}>
      <div className="e-con-inner">
        <div className="elementor-element-icon3 elementor-widget elementor-widget-image">
          <div className="elementor-widget-container" style={{ display: 'grid', marginBottom: '20px' }}>
            <img src={dfm_icon} alt="Design for Manufacturability (DFM)" />
          </div>
        </div>
        <div className="elementor-element-title3 elementor-widget elementor-widget-heading">
          <div className="elementor-widget-container">
            <h3 className="elementor-heading-title" style={{ fontSize: '20px', color: '#004E98', marginBottom: '10px' }}>Design for Manufacturability (DFM)</h3>
          </div>
        </div>
        <div className="elementor-element-desc3 elementor-widget elementor-widget-text-editor">
          <div className="elementor-widget-container">
            <p style={{ fontSize: '18px' }}>Ensures innovative machine design for smooth production processes.</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<style>{`
  @media (max-width: 768px) {
    .elementor-element-new-section .e-con-inner {
      flex-direction: column !important;
      gap: 30px;
      padding: 0 20px;
    }

    .elementor-element-new-item1,
    .elementor-element-new-item2,
    .elementor-element-new-item3 {
      width: 100% !important;
      margin-right: 0 !important;
      padding: 0 !important;
    }

    .elementor-element-icon1 img,
    .elementor-element-icon2 img,
    .elementor-element-icon3 img {
      margin: 0 auto;
    }

    .elementor-element-new-section > .e-con-inner > div:nth-child(2),
    .elementor-element-new-section > .e-con-inner > div:nth-child(4) {
      display: none;
    }

    .elementor-element-47da202 {
      padding: 0 15px !important;
      margin-top: 20px;
      width: 100% !important;
    }

    .custom-video {
      width: 100% !important;
      height: auto !important;
      aspect-ratio: 16/9;
      object-fit: cover;
      display: block;
    }

    .custom-video:hover {
    transform: none !important;
    filter: none !important;
    transition: none !important;

    .elementor-heading-title,
    .elementor-widget-text-editor p {
      text-align: center !important;
    }
  }
`}</style>



    </>
)
}
export default OurServices;